export const socialIcons = [
  {
    title: "discord",
    img: (
      <svg
        width="21"
        height="16"
        viewBox="0 0 21 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.6827 1.47711C16.3861 0.881894 15.0177 0.457449 13.6118 0.21441C13.599 0.212046 13.5859 0.21377 13.5741 0.219335C13.5624 0.2249 13.5527 0.234024 13.5464 0.24541C13.3706 0.558011 13.1758 0.966012 13.0395 1.28661C11.5022 1.05641 9.97292 1.05641 8.46721 1.28661C8.33081 0.958812 8.12901 0.558011 7.95241 0.24541C7.94587 0.234258 7.93613 0.225334 7.92444 0.219804C7.91276 0.214274 7.89968 0.212394 7.88691 0.21441C6.48092 0.456958 5.11246 0.881422 3.816 1.47711C3.8049 1.48182 3.79554 1.48986 3.7892 1.50011C1.19639 5.37372 0.486191 9.15213 0.834592 12.8837C0.835562 12.8929 0.838364 12.9017 0.842831 12.9098C0.847298 12.9178 0.853339 12.9249 0.860592 12.9305C2.5712 14.1868 4.2283 14.9495 5.85461 15.4551C5.86726 15.4588 5.88076 15.4586 5.8933 15.4545C5.90585 15.4504 5.91684 15.4426 5.92481 15.432C6.30951 14.9066 6.65241 14.3527 6.94651 13.7702C6.95056 13.7623 6.95287 13.7535 6.95329 13.7446C6.95372 13.7356 6.95224 13.7267 6.94896 13.7184C6.94568 13.7101 6.94067 13.7025 6.93427 13.6963C6.92787 13.69 6.92021 13.6852 6.91181 13.6821C6.36781 13.4757 5.84991 13.2242 5.3517 12.9385C5.34263 12.9332 5.33501 12.9257 5.32952 12.9167C5.32402 12.9077 5.32082 12.8975 5.3202 12.887C5.31958 12.8765 5.32155 12.866 5.32595 12.8564C5.33034 12.8469 5.33702 12.8385 5.3454 12.8321C5.4505 12.7536 5.5538 12.6726 5.6552 12.5893C5.66408 12.582 5.67484 12.5773 5.68625 12.5757C5.69767 12.5742 5.70929 12.5758 5.71981 12.5805C8.99301 14.0749 12.5365 14.0749 15.771 12.5805C15.7816 12.5755 15.7933 12.5736 15.8049 12.5751C15.8165 12.5765 15.8275 12.5811 15.8365 12.5885C15.938 12.6723 16.0416 12.7535 16.1471 12.8321C16.1556 12.8385 16.1623 12.8468 16.1667 12.8563C16.1712 12.8658 16.1733 12.8763 16.1727 12.8868C16.1722 12.8973 16.1691 12.9075 16.1636 12.9166C16.1582 12.9256 16.1507 12.9331 16.1416 12.9385C15.6431 13.2296 15.121 13.4781 14.5807 13.6813C14.5723 13.6846 14.5647 13.6895 14.5584 13.6958C14.552 13.7022 14.5471 13.7098 14.5439 13.7182C14.5407 13.7266 14.5393 13.7356 14.5398 13.7445C14.5403 13.7535 14.5427 13.7623 14.5468 13.7702C14.846 14.3481 15.1872 14.9033 15.5676 15.4313C15.5754 15.4421 15.5863 15.4502 15.5989 15.4544C15.6115 15.4587 15.6251 15.4589 15.6378 15.4551C17.272 14.9495 18.9291 14.1868 20.6398 12.9305C20.6472 12.9251 20.6533 12.9183 20.6578 12.9103C20.6622 12.9024 20.665 12.8936 20.6658 12.8845C21.0828 8.57043 19.9673 4.82292 17.7087 1.50091C17.7032 1.49012 17.694 1.48167 17.6827 1.47711ZM7.43531 10.6116C6.44981 10.6116 5.63781 9.70693 5.63781 8.59583C5.63781 7.48473 6.43411 6.58003 7.43531 6.58003C8.44431 6.58003 9.24841 7.49273 9.23261 8.59583C9.23261 9.70693 8.43641 10.6116 7.43531 10.6116ZM14.0809 10.6116C13.0954 10.6116 12.2835 9.70693 12.2835 8.59583C12.2835 7.48473 13.0797 6.58003 14.0809 6.58003C15.0899 6.58003 15.894 7.49273 15.8783 8.59583C15.8783 9.70693 15.0899 10.6116 14.0809 10.6116Z"
          fill="currentColor"
        />
      </svg>
    ),
    url: "https://discord.gg/Ku4kSsh9Tw",
  },
  {
    title: "twitter",
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="17"
        viewBox="0 0 18 17"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.7431 9.01204L0 0.5H5.341L9.50346 5.76103L13.9504 0.523688H16.8919L10.9257 7.55865L18 16.5H12.675L8.16784 10.8105L3.35606 16.4843H0.398583L6.7431 9.01204ZM13.4511 14.9228L3.27493 2.07713H4.56424L14.7276 14.9228H13.4511Z"
          fill="currentColor"
        />
      </svg>
    ),
    url: "https://twitter.com/vanarchain",
  },
  {
    title: "telegram",
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="18"
        viewBox="0 0 20 18"
        fill="none"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.9593 16.3852L16.9599 16.3836L16.9775 16.3412L20 1.59794V1.55005C20 1.18271 19.8597 0.862027 19.5544 0.669671C19.2872 0.501301 18.98 0.48931 18.7647 0.505128C18.5369 0.521856 18.322 0.576869 18.1733 0.622662C18.0968 0.646221 18.0328 0.668921 17.987 0.68609C17.964 0.694707 17.9454 0.702019 17.9319 0.707467L17.9186 0.712886L1.06641 7.10877L1.06177 7.11038C1.05267 7.11359 1.04063 7.11793 1.0261 7.12341C0.997114 7.13432 0.957664 7.14994 0.91132 7.17026C0.820324 7.21016 0.694601 7.27173 0.567098 7.35621C0.350544 7.49968 -0.0618076 7.83935 0.00782129 8.37784C0.0654948 8.82388 0.383293 9.10716 0.597544 9.25383C0.712395 9.33245 0.822271 9.38914 0.902731 9.4262C0.943499 9.44498 0.978129 9.45936 1.00392 9.46952C1.01685 9.47462 1.02766 9.47869 1.03602 9.48176L1.04673 9.48563L1.05358 9.48809L4.00197 10.4484C3.99202 10.6274 4.01037 10.8099 4.05943 10.9899L5.53631 16.4101C5.71142 17.0528 6.31236 17.5005 6.99933 17.5C7.61509 17.4996 8.16121 17.1392 8.39322 16.6015L10.699 14.2162L14.6591 17.1535L14.7154 17.1773C15.0752 17.3292 15.4113 17.3773 15.7187 17.3367C16.0256 17.2962 16.2695 17.1716 16.4526 17.0298C16.6329 16.8903 16.7565 16.7328 16.8342 16.6142C16.8736 16.554 16.9031 16.5011 16.9235 16.4612C16.9337 16.4412 16.9418 16.4243 16.9479 16.4111L16.9555 16.3941L16.9582 16.3878L16.9593 16.3852ZM5.52131 10.617C5.48774 10.4939 5.54043 10.3638 5.65159 10.2955L15.6521 4.15124C15.6521 4.15124 16.2403 3.80575 16.2193 4.15124C16.2193 4.15124 16.3243 4.21225 16.0091 4.49673C15.7101 4.76691 8.88145 11.1454 8.19049 11.7908C8.1506 11.8281 8.1268 11.8708 8.11274 11.9227L6.99819 16.0373L5.52131 10.617Z"
          fill="currentColor"
        />
      </svg>
    ),
    url: "https://t.me/vanarofficial",
  },
  {
    title: "medium",
    img: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
      >
        <g clipPath="url(#clip0_7883_2967)">
          <path
            d="M13.2871 11.9881C13.2871 15.4009 10.5393 18.1674 7.14986 18.1674C3.76046 18.1674 1.01245 15.4009 1.01245 11.9881C1.01245 8.57537 3.76025 5.80859 7.14986 5.80859C10.5395 5.80859 13.2871 8.57537 13.2871 11.9881Z"
            fill="currentColor"
          />
          <path
            d="M20.0197 11.988C20.0197 15.2003 18.6458 17.8055 16.951 17.8055C15.2562 17.8055 13.8823 15.2003 13.8823 11.988C13.8823 8.77559 15.256 6.17041 16.9508 6.17041C18.6456 6.17041 20.0195 8.77475 20.0195 11.988"
            fill="currentColor"
          />
          <path
            d="M22.7736 11.988C22.7736 14.8655 22.2904 17.1996 21.6943 17.1996C21.0982 17.1996 20.6152 14.8661 20.6152 11.988C20.6152 9.10985 21.0984 6.77637 21.6943 6.77637C22.2902 6.77637 22.7736 9.10964 22.7736 11.988Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_7883_2967">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    url: "https://medium.com/vanarchain",
  },
];
export const vanryLogo = {
  header: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="40"
      viewBox="0 0 46 40"
      fill="none"
    >
      <g clipPath="url(#clip0_14571_27613)">
        <path
          d="M28.7448 39.6111L34.4925 29.7039L17.2493 0H5.74776L0 9.90129H11.5075L28.7448 39.6111ZM40.2463 19.8026L46 9.90129L40.2463 0H28.7507L23.003 9.90129H34.4985L40.2463 19.8026Z"
          fill="#03D9AF"
        />
        <path
          d="M34.9218 10.2222L40.8889 0H28.9609L23 10.2222H34.9218Z"
          fill="#03D9AF"
        />
        <path
          d="M11.9218 10.2222L17.8889 0H5.96089L0 10.2222H11.9218Z"
          fill="#03D9AF"
        />
      </g>
      <defs>
        <clipPath id="clip0_14571_27613">
          <rect width="46" height="39.6111" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  footer: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="46"
      height="39"
      viewBox="0 0 46 39"
      fill="none"
    >
      <g clipPath="url(#clip0_14675_5188)">
        <path
          d="M28.7448 38.2376L34.4925 28.6739L17.2493 0H5.74776L0 9.55796H11.5075L28.7448 38.2376ZM40.2463 19.1159L46 9.55796L40.2463 0H28.7507L23.003 9.55796H34.4985L40.2463 19.1159Z"
          fill="#03D9AF"
        />
        <path
          d="M34.4925 9.55796L40.2463 0L28.7448 6.84744e-07L22.997 9.55796H34.4925Z"
          fill="#03D9AF"
        />
        <path
          d="M11.4955 9.55796L17.2493 0H5.74776L0 9.55796L11.4955 9.55796Z"
          fill="#03D9AF"
        />
      </g>
      <defs>
        <clipPath id="clip0_14675_5188">
          <rect width="46" height="38.2376" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
};
